// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PB12","tabsBox":"styles_tabsBox__md1Mz","createButton":"styles_createButton__5eLSW"};